import React from 'react';
import PropTypes from 'prop-types';

// Assets
import {grey300} from "assets/jss/main";
import {ReactComponent as RefreshIcon} from 'assets/img/wms/refresh-2.svg';

RefreshButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};

function RefreshButton({onClick}) {
    return (
        <button
            onClick={onClick}
            style={{
                padding: '12px 16px',
                background: grey300,
                borderRadius: '8px',
                border: 'none',
            }}
        >
            <RefreshIcon />
        </button>
    );
}

export default RefreshButton;
